
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1536 1541"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1312 770c0-107.3-29-205.7-87-295l-754 753c91.3 59.3 190.3 89 297 89 74 0 144.5-14.5 211.5-43.5s124.8-67.8 173.5-116.5 87.3-106.8 116-174.5 43-138.5 43-212.5zm-999 299l755-754c-90-60.7-190-91-300-91-98.7 0-189.7 24.3-273 73S345.7 412 297 496s-73 175.3-73 274c0 108 29.7 207.7 89 299zm1223-299c0 104.7-20.3 204.7-61 300s-95.2 177.3-163.5 246-150 123.3-245 164-194.5 61-298.5 61-203.5-20.3-298.5-61-176.7-95.3-245-164S101.7 1165.3 61 1070 0 874.7 0 770s20.3-204.5 61-299.5S156.2 293.7 224.5 225s150-123.3 245-164S664 0 768 0s203.5 20.3 298.5 61 176.7 95.3 245 164 122.8 150.5 163.5 245.5 61 194.8 61 299.5z"}})])
          )
        }
      }
    